import { subDays } from 'date-fns'
import { useMemo } from 'react'
import { useOrganizationDatastore } from '~/features/datastore'

import { Timespan } from '@hap/utils'

export function useMaxDate() {
  const { data: organization } = useOrganizationDatastore()
  return useMemo(() => {
    return organization?.maxDate ? new Date(organization?.maxDate) : new Date()
  }, [])
}

export function useDefaultTimespan(
  startOffset:
    | number
    | ((maxDate: Date, weekStartsOn: Timespan.DayOfWeek) => Date) = 14,
  weekStartsOn: Timespan.DayOfWeek = 1,
): Timespan.StaticTimespan {
  const { data: organization } = useOrganizationDatastore()
  const maxDate = organization ? organization.maxDate : new Date()
  return useMemo(
    () => ({
      type: 'static',
      start:
        typeof startOffset === 'function'
          ? startOffset(new Date(maxDate), weekStartsOn)
          : subDays(new Date(maxDate), startOffset),
      end: new Date(maxDate),
    }),
    [maxDate, startOffset, weekStartsOn],
  )
}
